module.exports = __webpack_public_path__ + "static/media/新垃圾分类-PNG.d7a9bd42.png";